(function($){
    const $fn = $(".comp_site_magazine_detail");

    if ($fn.length) {

    }
})(jQuery);